import { formatZero } from "@/util/util";
const parseToTime = (date: any) => {
  if (!date) {
    return "";
  }
  const d = new Date(date);
  const h = formatZero(d.getHours());
  const m = formatZero(d.getMinutes());
  const s = formatZero(d.getSeconds());
  return `${h}:${m}:${s}`;
};
export default {
  parseToTime
};
